<template>
  <v-card>
    <v-card-title class="d-flex">
      <v-icon start color="grey">mdi-filter</v-icon> Filter
      <v-icon @click="save" class="ml-auto" end color="grey">mdi-close</v-icon>
    </v-card-title>
    <v-card-text class="px-3 py-8">
      <v-form>
        <sorter
          v-model="sorts"
          :sortableFields="sortableFields"
          :SortTypes="SortTypes"
        />
      </v-form>
      <v-form :ref="form">
        <v-text-field
          v-model="Belegnr"
          :rules="[ruleInt]"
          variant="outlined"
          hide-details
          placeholder="Belegnr"
          class="mb-4"
          clearable
        />
        <v-select
          v-model="filters.Erledigt"
          item-title="text"
          item-value="value"
          :items="[{value: 'J', text: 'Ja'}, {value: 'N', text: 'Nein'}]"
          label="Erledigt"
          clearable
        />
        <date-picker
          v-model="DatumFrom"
          label="Datum von"
        />
        <date-picker
          v-model="DatumTo"
          label="Datum bis"
        />
        <v-text-field
          v-model="Bediener"
          :rules="[ruleUserShort]"
          variant="outlined"
          hide-details
          label="Bediener"
          maxlength="5"
          clearable
        />

      </v-form>
    </v-card-text>
    <v-divider></v-divider>

    <v-card-actions class="text-center">
      <v-btn color="grey" class="flex-1" variant="outlined" size="large" @click="reset">Zurücksetzen</v-btn>
      <v-btn class="flex-1 btn-navigator-primary" size="large" @click="save">Speichern</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">
import {computed, ref, watch} from 'vue';
import DatePicker from '../DatePicker.vue';
import Sorter from '../Sorter.vue';
import useInventoriesStore from '@/store/inventories';
import {useFilterSort} from '@/composables/filterSort';
import {VNodeRef} from 'vue';

const emits = defineEmits(['close']);
const store = useInventoriesStore();

const {save, reset, filters, sorts, SortTypes} = useFilterSort(store, emits);

const sortableFields = ref([
  {
    text: 'Belegnr',
    value: 'Belegnr',
  },
  {
    text: 'Datum',
    value: 'Datum',
  },
]);
const form = ref<HTMLFormElement & VNodeRef | undefined>();

const Belegnr = computed({
  get() {
    return filters.value.Belegnr;
  },
  set(Belegnr: string | number | undefined) {
    filters.value.Belegnr = Belegnr ? parseInt(Belegnr as string) : undefined;
  },
});
const DatumFrom = computed({
  get() {
    return filters.value.Datum$From;
  },
  set(val: string | undefined) {
    if (!val) filters.value.Datum$From = undefined;
    else filters.value.Datum$From = val;
  },
});
const DatumTo = computed({
  get() {
    return filters.value.Datum$To;
  },
  set(val: string | undefined) {
    if (!val) filters.value.Datum$To = undefined;
    else filters.value.Datum$To = val;
  },
});
const Bediener = computed({
  get() {
    return filters.value.Bediener;
  },
  set(val: string | null | undefined) {
    if (!val) filters.value.Bediener = undefined;
    else filters.value.Bediener = val.toUpperCase();
  },
});

function ruleInt(val: string | number | undefined | null): string|true {
  if (!val) return true;

  if (parseInt(val as string).toString() !== val.toString()) return 'bitte eine ganze Zahl eingeben';

  return true;
}
function ruleUserShort(val: string | undefined | null): string|true {
  if (!val) return true;

  if (val.length > 5) return 'zu lang';

  return true;
}

watch(form, () => {
  form.value?.validate();
});

defineExpose({
  Sorter, DatePicker,
  save, reset, filters, sorts, SortTypes,
  ruleInt, ruleUserShort,
  Belegnr,
  DatumFrom,
  DatumTo,
  Bediener,
  sortableFields,
  form,
});

</script>
<style scoped>
  .fixed-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
  }
  .v-card__actions {
    justify-content: center;
  }
</style>
